export default __webpack_public_path__ + "static/6-fc5dca9a531a9a5256631d6e8a4da4a5.png";